


























import Vue from 'vue';
import AdminNav from '@/components/Nav/AdminNav.vue';

export default Vue.extend({
  components: {
    AdminNav
  },
  props: {
    componentList: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: true
    }
  }
});
